import { Box } from "@mui/material";
import { QRCodeSVG } from "qrcode.react";

export const CodeQr = ({ value, image }) => {
  return (
    <Box width={150} height={150} overflow={"hidden"}>
      <QRCodeSVG
        value={value}
        size={150}
        bgColor="trasparent"
        fgColor={"#dcdcdc"}
        level={"L"}
        imageSettings={{
          src: image,
          x: undefined,
          y: undefined,
          height: 35,
          width: 35,
          excavate: true,
        }}
      />
    </Box>
  );
};
